type AuthErrorLike =
  | { name?: string; message?: string; code?: string | number | null; status?: number }
  | null
  | undefined;

export function isRecoverableSupabaseAuthError(authError: AuthErrorLike): boolean {
  if (!authError) {
    return false;
  }

  if (authError.name === 'AuthSessionMissingError') {
    return true;
  }

  const errorCode =
    typeof authError.code === 'string'
      ? authError.code.toLowerCase()
      : String(authError.code ?? '').toLowerCase();
  const errorMessage = authError.message?.toLowerCase() ?? '';

  if (errorCode === 'refresh_token_already_used' || errorCode === 'refresh_token_not_found') {
    return true;
  }

  if (errorMessage.includes('invalid refresh token')) {
    return true;
  }

  if (errorMessage.includes('refresh token is not valid')) {
    return true;
  }

  return false;
}
